<script lang="ts">
	import type { Notification as NotificationType } from '$lib/components/notification/store.svelte';

	import { page } from '$app/state';
	import Notification from '$lib/components/notification/Notification.svelte';
	import { m } from '$lib/paraglide/messages.js';

	let isLoading = $state(false);

	let notification: NotificationType | null = $state(null);

	async function handleSubmit(e: SubmitEvent & { currentTarget: EventTarget & HTMLFormElement }) {
		e.preventDefault();

		const data = new FormData(e.currentTarget);

		isLoading = true;
		const newsletterResponse = await fetch('/api/transactional/newsletter/subscribe', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ email: data.get('email'), store_id: page.data.store.store_id }),
		});
		isLoading = false;

		if (newsletterResponse.ok) {
			notification = {
				type: 'success',
				message: m['newsletter.footer.email_sent'](),
			};
		} else if (newsletterResponse.status === 409) {
			notification = {
				type: 'error',
				message: m['newsletter.subscription.failure.already_subscribed'](),
			};
		} else if (newsletterResponse.status === 400) {
			notification = {
				type: 'success',
				message: m['newsletter.subscription.failure.invalid_email'](),
			};
		} else {
			notification = {
				type: 'error',
				message: m['newsletter.subscription.failure.text'](),
			};
		}
	}
</script>

<div class="flex flex-col border-t pt-4 text-white xl:border-0 xl:pt-0">
	<h3 class="font-bold uppercase">
		{m['newsletter.footer.subscribe_title']()}
	</h3>
	<span class="mb-4">{m['newsletter.footer.subscribe_description']()}</span>

	{#if notification}
		<Notification {...notification} />
	{/if}

	<form onsubmit={handleSubmit} inert={isLoading} class="flex max-w-xl gap-2">
		<input
			type="email"
			inputmode="email"
			autocomplete="email"
			name="email"
			placeholder={m['newsletter.footer.email_placeholder']()}
			class="flex-1 rounded bg-white p-2 text-black"
			required
		/>
		<button
			type="submit"
			class={[
				'cursor-pointer rounded border-1 px-8 font-bold hover:bg-white hover:text-neutral-900',
				{ 'animate-pulse': isLoading },
			]}
		>
			{m['newsletter.footer.subscribe']()}
		</button>
	</form>
</div>
